import React, { ReactElement, useContext } from 'react';
import StringsContext from '../../data/stringsContext';
import { CalciteLink } from '@esri/calcite-components-react';
import { getFeatureLayerServer } from '../../util/urlUtils';
import { ILayerDefinition } from '@esri/arcgis-rest-feature-service';
import { useAccountManager } from '../../contexts/AccountManagerContext';
import { CalciteOverride } from '../../util/calciteUtils';

export default function Header({
  layerDefinition,
  url,
}: {
  layerDefinition?: ILayerDefinition | null;
  url: string;
}): ReactElement {
  const strings = useContext(StringsContext);
  const { accountManager } = useAccountManager();

  const openArcgisUrl = async (url: string) => {
    if (accountManager) {
      const token = await accountManager.getToken(url);
      return window.open(`${url}?token=${token}`, '_blank');
    }
    return window.open(url, '_blank');
  };

  const featureLayerInfo = getFeatureLayerServer(url);

  return (
    <div className="flex items-center p-2 pl-4 flex-1 min-w-0">
      <span className="hidden lg:flex">
        <div className="text-3 whitespace-nowrap">Table Editor</div>
        <span
          className="text-n3 text-danger px-1 pb-3"
          title={strings.alphaWarning}
        >
          {strings.alpha}
        </span>
      </span>

      <div className="text-2 pl-4 flex overflow-ellipsis overflow-hidden">
        {featureLayerInfo && (
          <span className="hidden md:flex">
            <CalciteLink
              onClick={() => openArcgisUrl(featureLayerInfo[0])}
              target="_blank"
            >
              {featureLayerInfo[1]}
            </CalciteLink>
            <span className="px-2">{' > '}</span>
          </span>
        )}

        <CalciteOverride
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          <CalciteLink
            onClick={() => openArcgisUrl(url)}
            target="_blank"
            style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {layerDefinition?.name}
          </CalciteLink>
        </CalciteOverride>
      </div>
    </div>
  );
}
